
export type Course = {
    id?: string,
    offerId: string,
    subjectId: string,
    cartIndex: number,
    extraCourse: any,
    type: 'basic' | 'elective',
    language: 'en' | 'es',
    courseId: string,
    courseName: string,
    subjectName: string,
    gradeName: string,
    workbook: boolean,
    workbookPrice: number
}

export type CourseInfo = {
    id: string,
    subject: string,
    grade: string,
    language: string,
    license_type: number,
    name: string,
    workbook: boolean,
    active: boolean,
    workbook_price?: number
}

export type CourseMap = {
    [key: string]: CourseInfo
}

export function isElective(course: Course) {
    return (course.courseId || course.id || '').startsWith('C7')
}

export function getCourseSubject(course: Course) {
    return course.courseId.substring(0, 2)
}

export type Subject = {
  id: string;
  name: { en: string; es: string };
}

export type Grade = {
  id: string;
  name: { en: string; es: string };
  precedence: number;
}

